import React, { useMemo, useEffect, useState, useRef } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { tryNow } from "../../../../utils";
import classNames from "classnames";
import { AuthingButton } from "../../../../components/AuthingButton";
import smoothscroll from "smoothscroll-polyfill";

export const ManufacturingBanner = () => {
  const { t } = useTranslation();
  const titles = useMemo(() => {
    return [
      {
        title: t("manufacturing.banner.title"),
        subtitle: t("manufacturing.banner.subtitle"),
      },
    ];
  }, [t]);
  const orders = useMemo(() => {
    return [
      {
        imgUrl: "https://files.authing.co/authing-website/manu-1-logo1.png",
        alt: "",
        linkIndex: 3,
      },
      {
        imgUrl: "https://files.authing.co/authing-website/manu-1-logo2.png",
        alt: "",
        linkIndex: 2,
      },
      {
        imgUrl: "https://files.authing.co/authing-website/manu-1-logo3.png",
        alt: "",
      },
      {
        imgUrl: "https://files.authing.co/authing-website/manu-1-logo4.png",
        alt: "",
      },
      {
        imgUrl: "https://files.authing.co/authing-website/manu-1-logo5.png",
        alt: "",
        linkIndex: 0,
      },
      {
        imgUrl: "https://files.authing.co/authing-website/manu-1-logo6.png",
        alt: "",
        linkIndex: 4,
      },
      {
        imgUrl: "https://files.authing.co/authing-website/manu-1-logo7-k.png",
        alt: "",
        linkIndex: 1,
      },
    ];
  }, []);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      if (currentIndex < titles.length - 1) {
        setCurrentIndex(currentIndex + 1);
      } else {
        setCurrentIndex(0);
      }
    }, 5000);
    return () => clearInterval(timer);
  }, [currentIndex, titles]);
  const [visible, setVisible] = useState(false);
  const tabWrapper = useMemo(() => {
    return (
      <div className="manufacturing-banner-carousel-container-order swiper-wrapper">
        {[...orders, ...orders].map((order, index) => {
          return (
            <div
              className={classNames("container-order swiper-slide")}
              key={index}
            >
              <img src={order.imgUrl} alt={order.alt} />
            </div>
          );
        })}
      </div>
    );
  }, [orders]);
  const flag = useRef();
  // useEffect(() => {
  //   smoothscroll.polyfill();
  //   flag.current = setTimeout(() => {
  //     if (document.body.scrollTop === 0) {
  //       window.scrollTo({
  //         left: 0,
  //         top: (sessionStorage.getItem("windowWidth") / 1920) * 1000,
  //         behavior: "smooth",
  //       });
  //     }
  //   }, 3000);
  //   const lister = function () {
  //     clearInterval(flag.current);
  //   };
  //   window.addEventListener("scroll", lister);
  //   return () => {
  //     clearInterval(flag.current, lister);
  //   };
  // }, []);
  useEffect(() => {
    new Swiper(".manufacturing-banner-swiper", {
      spaceBetween: 24,
      slidesPerView:
        JSON.parse(sessionStorage.getItem("windowWidth")) > 1200 ? 6 : 4,
      // slidesPerView: "auto",
      loop: true,
      // centeredSlides: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    });
  }, []);
  const openROI = () => {
    window.open("https://host.huiju.cool/p/b1e3e");
  };
  return (
    <div className="manufacturing-banner">
      <div className="manufacturing-banner-carousel-container-warp">
        {titles.map((item, index) => {
          const className = classNames({
            "manufacturing-banner-carousel-container": true,
            visible: currentIndex === index,
          });
          return (
            <div className={className} key={index}>
              <div className="container-item basic-column">
                <h1 className="slogn">{item.title}</h1>
                <div className="descrption">{item.subtitle}</div>

                <AuthingButton
                  style={{ marginRight: 24 }}
                  onClick={() => {
                    window.open("https://www.authing.cn/authingform");
                  }}
                >
                  {t("common.button.consult")}
                </AuthingButton>
                <AuthingButton mode="light" onClick={openROI}>
                  {t("common.button.try-now-roi")}
                </AuthingButton>
              </div>
            </div>
          );
        })}
        <div className="manufacturing-banner-carousel-container-order-wrap">
          <div className="basic-column">
            <div className="swiper manufacturing-banner-swiper">
              {tabWrapper}
            </div>
          </div>
          {/* <div class="pad-show mobile-show">{tabWrapper}</div> */}
        </div>
      </div>
    </div>
  );
};
